import React from 'react';

import { Box, CircularProgress } from '@mui/material';
import palette from 'theme/palette';

const styles = {
  root: {
    position: 'relative',
  },
  top: {
    color: palette.primary.main,
    animationDuration: '1000ms',
    position: 'absolute',
    left: 0,
  },
  bottom: {
    color: palette.primary.light,
    animationDuration: '300ms',
    position: 'absolute',
    left: 0,
  },
};

type Props = {
  size?: number;
};
/**
 * A custom circular progress bar to indicate loading.
 * @param size The size of the circular progress in pixels
 */
const CustomCircularProgress = ({ size = 27 }: Props) => {
  return (
    <Box sx={styles.root}>
      <CircularProgress variant="determinate" value={100} sx={styles.top} size={size} thickness={4} />
      <CircularProgress variant="indeterminate" disableShrink sx={styles.bottom} size={size} thickness={4} />
    </Box>
  );
};

export default CustomCircularProgress;
